import { useTranslation } from "react-i18next";

export function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  const toggle = () => {
    const next = current === "es" ? "en" : "es";
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      title={current === "es" ? "Switch to English" : "Cambiar a Español"}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-white/[0.1] bg-white/[0.04] hover:bg-white/[0.08] transition-all text-xs font-bold tracking-wide ${className}`}
      style={{ color: "#D4AF37" }}
    >
      <span style={{ fontSize: 14, lineHeight: 1 }}>
        {current === "es" ? "🇺🇸" : "🇪🇸"}
      </span>
      <span>{current === "es" ? "EN" : "ES"}</span>
    </button>
  );
}
